import { render, staticRenderFns } from "./person.vue?vue&type=template&id=46d3bddf&scoped=true&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"
import style0 from "./person.vue?vue&type=style&index=0&module=true&lang=css&"
import style1 from "./person.vue?vue&type=style&index=1&id=46d3bddf&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "46d3bddf",
  null
  
)

export default component.exports